import React, { createContext, useContext, useEffect, useState } from 'react';
import { IExpandedTourDate } from '../components/tour-offer/models/IExpandedTourDate';
import TourDateService from '../components/tour-offer/services/TourDateService';

interface TourDateContextType {
    allDates: IExpandedTourDate[];
    getDatesByTourId: (tourId: number) => IExpandedTourDate[];
    getAllDates: () => IExpandedTourDate[];
}

const TourDateContext = createContext<TourDateContextType | undefined>(undefined);

export const TourDateProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [allDates, setAllDates] = useState<IExpandedTourDate[]>([]);

    useEffect(() => {
        const fetchDates = async () => {
            const grouped = await new TourDateService().getTourDatesGroupedByYear();
            const flat = Object.values(grouped).flat();
            setAllDates(flat);
        };
        fetchDates();
    }, []);

    const getDatesByTourId = (tourId: number) =>
        allDates.filter(date => date.tour.id === tourId);

    const getAllDates = () => {
        return allDates;
    }

    return (
        <TourDateContext.Provider value={{ allDates, getDatesByTourId, getAllDates }}>
            {children}
        </TourDateContext.Provider>
    );
};

export const useTourDates = () => {
    const context = useContext(TourDateContext);
    if (!context) throw new Error('useTourDates must be used within TourDateProvider');
    return context;
};